import { Http } from '../../../support';

export const initialState = {
  data: {
    tipo: 'timbrado-retenciones',
  },
  busy: false,
  progress: 0,
  error: undefined,
  result: undefined,
};

const reset = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.upload = { ...initialState };
  });
};

const onChange = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.upload.data = {
      ...state.modulo.retenciones_masivas.files.upload.data,
      ...data,
    };
  });
};

const progress = (store, progress) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.upload.progress = progress;
  });
};

const upload = async (store, onUploadProgress = () => {}) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.files.upload.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    };

    const { upload } = store.state.modulo.retenciones_masivas.files;

    let formData = new FormData();

    formData.append('file', upload.data.file);
    formData.append('tipo', upload.data.tipo);
    formData.append('fallback', upload.data.fallback || false);

    const response = await Http.post(`${window.BONJOUR_URL}/api/timbrado-masivo/retenciones/files`, formData, options);

    store.setState((state) => {
      state.modulo.retenciones_masivas.files.upload.busy = false;
      state.modulo.retenciones_masivas.files.upload.progress = 100;
      state.modulo.retenciones_masivas.files.upload.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.retenciones_masivas.files.upload.busy = false;
      state.modulo.retenciones_masivas.files.upload.error = error.data || error;
    });
  }
};

const RetencionesMasivasFilesUploadStore = {
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    upload,
  },
};

export default RetencionesMasivasFilesUploadStore;
